
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Wagholitomumbaicab() {



    const cardData =
    {
        keyword: ' Wagholi to Mumbai Cab',
        heading: 'Prince Cabs: Wagholi to Mumbai Cab',
        headingDescription: 'Prince Cabs offers reliable Wagholi to Mumbai Cab services, perfect for airport transfers, corporate travel, family trips, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride from Wagholi to Mumbai via the expressway. With professional chauffeurs, punctual pickups, and flexible booking options, we make your travel smooth and stress-free. Choose Prince Cabs’ trusted cab service from Wagholi to Mumbai for comfort, reliability, and affordability.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. The site is a bustling hub with tourists, photographers, and ferry rides to Elephanta Caves. At sunset, the arch glows beautifully against the skyline. It remains the proud symbol of South Mumbai. Gateway of India is the city’s historic and cultural centerpiece."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km crescent-shaped boulevard along the Arabian Sea. Locals and tourists flock here for evening walks, sea breezes, and stunning sunsets. At night, its streetlights resemble a sparkling necklace. During monsoon, waves dramatically crash against the promenade. It reflects the modern, vibrant spirit of Mumbai. Marine Drive is the heart of the city’s leisure life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage railway station built in 1887. Its Gothic Revival architecture features domes, spires, stained glass windows, and intricate carvings. The building looks spectacular when illuminated at night. It is both a functional transport hub and a heritage monument. Tourists admire its grandeur while witnessing Mumbai’s lifeline—the local trains. CST symbolizes Mumbai’s blend of history and modernity."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are UNESCO-listed rock-cut temples dating to the 5th–6th centuries. The highlight is the magnificent Trimurti sculpture of Lord Shiva. The caves reflect India’s ancient artistry and spiritual traditions. Accessible by ferry from Gateway of India, the island offers peace away from the city. Lush greenery surrounds the caves, enhancing their charm. It is a must-visit for history and culture lovers."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, popular for street food and leisure walks. Vendors serve local delights like pav bhaji, bhel puri, and ice gola. Families gather in the evenings to enjoy the sea breeze and sunset. Bollywood celebrities residing nearby make it a star-spotting zone. The beach is lively with children playing and locals exercising. Juhu Beach is Mumbai’s vibrant coastal escape."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most visited shrines, dedicated to Lord Ganesha. Built in 1801, it attracts devotees, celebrities, and politicians daily. The golden dome and beautifully carved wooden doors add grandeur. Tuesdays are especially crowded with worshippers. Devotees believe wishes made here are fulfilled. Siddhivinayak Temple is the spiritual core of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge and an engineering marvel. It connects South Mumbai with the western suburbs, reducing travel time significantly. The bridge offers stunning views of the Arabian Sea and skyline. At night, its illuminated structure looks spectacular. Driving across the Sea Link is a thrilling experience. It is a modern symbol of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it is a blend of spirituality and architecture. The dargah is connected by a causeway accessible at low tide. Devotees from all religions visit to seek blessings. Its sea-facing setting creates a serene atmosphere. Haji Ali is Mumbai’s iconic spiritual landmark."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling street market and shopping paradise. Visitors shop for clothes, handicrafts, jewelry, and antiques at bargain prices. Iconic cafés like Leopold Café and Café Mondegar add to the charm. The area is always lively with both locals and tourists. Bargaining with street vendors is part of the fun. Colaba Causeway is the ultimate shopping and cultural hotspot of Mumbai."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan celebrations. Families and couples enjoy snacks like pav bhaji, kulfi, and bhel here. The beach is vibrant during evenings and festivals. It offers views of Marine Drive’s arc and the Arabian Sea. Children love playing in the sand and waves. Girgaon Chowpatty is Mumbai’s blend of tradition and leisure."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood filmmaking, spread over 500 acres. It has studios, artificial sets, and shooting zones for films and TV shows. Guided tours take visitors behind the scenes of movie production. Cinema lovers enjoy spotting live shoots. It is one of the largest film complexes in the world. Film City showcases Mumbai’s entertainment identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a vast green sanctuary within Mumbai, covering 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display Buddhist stupas and rock-cut monasteries dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and treks. It is rare to find such nature in a metro. This park blends history, wildlife, and adventure."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by greenery and skyscrapers. It is popular among birdwatchers, with species like herons and kingfishers often spotted. Joggers and photographers enjoy its promenade. During monsoon, the lake looks especially scenic with misty surroundings. It is a peaceful retreat within the bustling city. Powai Lake is Mumbai’s hidden natural gem."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the world’s largest meditation domes. Built in Burmese architectural style, it houses relics of Buddha. The golden dome accommodates thousands of meditators. Visitors attend meditation sessions and admire the grand design. Its seaside setting enhances tranquility. The pagoda symbolizes peace, spirituality, and harmony."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is an educational hub for astronomy enthusiasts. Sky shows inside its dome theatre explain stars, galaxies, and cosmic wonders. The adjoining Science Centre offers interactive exhibits on innovation and technology. Families and students find it educational yet entertaining. Special events are held during eclipses and celestial events. It is Mumbai’s hub of science and curiosity."
  }
],

"services": [
  {
    "name": "Wagholi to Mumbai Taxi Service",
    "description": "Reliable taxi service from Wagholi to Mumbai offering timely pickups, professional drivers, and comfortable rides. Perfect for business trips, family travel, or leisure journeys, ensuring a hassle-free experience."
  },
  {
    "name": "Wagholi to Mumbai Innova Cab",
    "description": "Travel in style and comfort with our Innova cab service from Wagholi to Mumbai. Spacious interiors and premium features make it ideal for families and corporate groups on long-distance trips."
  },
  {
    "name": "Wagholi to Mumbai Dzire Taxi",
    "description": "Affordable and efficient Dzire taxi rides from Wagholi to Mumbai, perfect for small groups and solo travelers seeking comfort and reliability without overspending."
  },
  {
    "name": "Wagholi to Mumbai Airport Cab",
    "description": "Book our dedicated airport taxi service for timely and stress-free transfers from Wagholi to Mumbai Airport. Drivers familiar with airport protocols ensure smooth drop-offs and pickups."
  },
  {
    "name": "Wagholi to Mumbai Ertiga Cab",
    "description": "Spacious Ertiga cab services from Wagholi to Mumbai, perfect for family trips and group travel. Offers a balance of comfort, economy, and ample luggage space for long journeys."
  },
  {
    "name": "Wagholi to Mumbai One Way Taxi",
    "description": "Convenient one way taxi service from Wagholi to Mumbai, suitable for quick, single trips without the need for round-trip commitments. Flexible booking and professional drivers included."
  },
  {
    "name": "Wagholi to Mumbai Round Trip Cab",
    "description": "Flexible round trip cab services from Wagholi to Mumbai with options for comfortable wait times and return rides. Perfect for day trips, business visits, or sightseeing tours."
  },
  {
    "name": "Wagholi to Mumbai Crysta Rental",
    "description": "Premium Innova Crysta rentals from Wagholi to Mumbai offering luxurious travel experiences with spacious seating, air conditioning, and professional chauffeurs ensuring a smooth journey."
  },
  {
    "name": "Wagholi to Mumbai Sedan Taxi",
    "description": "Comfortable sedan taxi options including Dzire and Etios for travel from Wagholi to Mumbai. Ideal for solo travelers, couples, and small families seeking economical yet comfortable rides."
  },
  {
    "name": "Wagholi to Mumbai Etios Cab",
    "description": "Budget-friendly Etios taxi services from Wagholi to Mumbai, focusing on safety, punctuality, and a smooth travel experience. Perfect for everyday commuters and casual travelers."
  },
  {
    "name": "Wagholi to Mumbai SUV Taxi",
    "description": "Powerful and spacious SUV taxi options for Wagholi to Mumbai travel. Great for rough roads, family outings, or group travels needing extra space and comfort."
  },
  {
    "name": "Wagholi to Mumbai Tempo Traveller",
    "description": "Large group travel made easy with Tempo Traveller rentals from Wagholi to Mumbai. Suitable for corporate outings, family reunions, and long-distance group tours with ample seating."
  },
  {
    "name": "Affordable Cab from Wagholi to Mumbai",
    "description": "Get budget-friendly and reliable cab options from Wagholi to Mumbai that do not compromise on safety, comfort, or service quality. Ideal for cost-conscious travelers."
  },
  {
    "name": "Wagholi to Mumbai Tour Cab",
    "description": "Customized tour cab services from Wagholi to Mumbai for sightseeing, leisure trips, or corporate tours. Professional drivers and well-maintained vehicles enhance your travel experience."
  },
  {
    "name": "Wagholi to Mumbai Luxury Car",
    "description": "Experience premium travel with luxury car rentals from Wagholi to Mumbai. Enjoy plush interiors, exclusive amenities, and chauffeur-driven services for a truly luxurious journey."
  }
],
"tableData": [
  ["Wagholi to Mumbai Taxi Service", "Wagholi to Mumbai Innova Cab"],
  ["Wagholi to Mumbai Dzire Taxi", "Wagholi to Mumbai Airport Cab"],
  ["Wagholi to Mumbai Ertiga Cab", "Wagholi to Mumbai One Way Taxi"],
  ["Wagholi to Mumbai Round Trip Cab", "Wagholi to Mumbai Crysta Rental"],
  ["Wagholi to Mumbai Sedan Taxi", "Wagholi to Mumbai Etios Cab"],
  ["Wagholi to Mumbai SUV Taxi", "Wagholi to Mumbai Tempo Traveller"],
  ["Affordable Cab from Wagholi to Mumbai", "Wagholi to Mumbai Tour Cab"],
  ["Wagholi to Mumbai Luxury Car"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Wagholi to Mumbai Cab Service",
    "WhyChoosedescription": "Prince Cabs provides trustworthy and punctual cab services from Wagholi, Pune to Mumbai. Serving business travelers, tourists, and families, our service ensures a safe, comfortable, and timely journey to various destinations in Mumbai including airports, city centers, and suburban areas. Starting your trip from Wagholi is hassle-free with our prompt pickups and door-to-door service."
  },
  {
    "WhyChooseheading": "Wide Range of Comfortable Vehicles",
    "WhyChoosedescription": "Choose from our fleet of well-maintained sedans and SUVs such as Swift Dzire, Honda Amaze, Innova Crysta, and Ertiga. Each vehicle is equipped with air conditioning, spacious seating, and ample luggage space, providing a relaxed and enjoyable ride for solo travelers, families, and groups."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Our pricing from Wagholi to Mumbai is clear and competitive, with no hidden charges. The fare includes fuel, tolls, driver allowances, and taxes, ensuring a hassle-free booking experience. Multiple payment options including UPI, credit/debit cards, net banking, and cash are accepted for your convenience."
  },
  {
    "WhyChooseheading": "Easy and Flexible Booking Options",
    "WhyChoosedescription": "Booking your Wagholi to Mumbai cab is quick and convenient via phone, WhatsApp, or our online portal. Instant confirmations, along with flexible cancellation and rescheduling policies, let you manage your travel plans easily and without stress."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers have extensive knowledge of the route from Wagholi to Mumbai and are committed to providing a safe, punctual, and courteous service. They assist with luggage and ensure a smooth, comfortable journey tailored to your needs."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
    "WhyChoosedescription": "We prioritize your safety by thoroughly cleaning and sanitizing each vehicle before every trip. Our cars are regularly maintained and equipped with essential safety features such as seat belts and airbags, providing a secure travel environment."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Travel",
    "WhyChoosedescription": "Prince Cabs offers round-the-clock customer support to assist you with bookings, itinerary changes, and any travel-related queries, ensuring your Wagholi to Mumbai cab experience is smooth and worry-free."
  }
]




























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab service from Wagholi to Mumbai?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable cab services from Wagholi, Pune to Mumbai for both one-way and round trips.',
    },
    {
        question: 'What types of vehicles are available for Wagholi to Mumbai trips?',
        answer: 'We provide a variety of vehicles including Swift Dzire, Innova, Ertiga, and Tempo Traveller to suit solo travelers, families, and groups.',
    },
    {
        question: 'How long does the journey from Wagholi to Mumbai take by cab?',
        answer: 'The journey typically takes around 3.5 to 4.5 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a one-way cab from Wagholi to Mumbai?',
        answer: 'Yes, Prince Cabs offers flexible one-way and round-trip packages tailored to your travel needs.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for Wagholi to Mumbai trips?',
        answer: 'Absolutely! All vehicles are regularly cleaned, sanitized, and serviced for your safety and comfort.',
    },
    {
        question: 'What are the approximate fares for Wagholi to Mumbai cab service?',
        answer: 'Fares vary based on vehicle type and trip details. Please contact Prince Cabs for an accurate and competitive quote.',
    },
    {
        question: 'How do I book a cab from Wagholi to Mumbai?',
        answer: 'You can book easily through our website or by calling our customer support team for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Rahul Jadhav",
        position: "Business Traveler",
        text: "Prince Cabs provided a smooth and comfortable ride from Wagholi to Mumbai. The driver was professional and the cab clean.",
        image: "/img/testimonial/testimonial-thumb-wagholi-mumbai-1.png",
    },
    {
        name: "Ms. Shruti Deshpande",
        position: "Family Traveler",
        text: "I had a great experience with Prince Cabs from Wagholi to Mumbai. Reliable service and clean vehicles.",
        image: "/img/testimonial/testimonial-thumb-wagholi-mumbai-2.png",
    },
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Wagholi to Mumbai Cab",
  "description": "Reliable and affordable cab services from Wagholi to Mumbai. Choose from Innova, Dzire, Ertiga, Sedan, Etios, Tempo Traveller, and luxury cars for one way, round trip, or airport transfers.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Wagholi",
      "addressRegion": "Pune, Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Wagholi to Mumbai Taxi Service",
    "Wagholi to Mumbai Innova Cab",
    "Wagholi to Mumbai Dzire Taxi",
    "Wagholi to Mumbai Airport Cab",
    "Wagholi to Mumbai Ertiga Cab",
    "Wagholi to Mumbai One Way Taxi",
    "Wagholi to Mumbai Round Trip Cab",
    "Wagholi to Mumbai Crysta Rental",
    "Wagholi to Mumbai Sedan Taxi",
    "Wagholi to Mumbai Etios Cab",
    "Wagholi to Mumbai SUV Taxi",
    "Wagholi to Mumbai Tempo Traveller",
    "Affordable Cab from Wagholi to Mumbai",
    "Wagholi to Mumbai Tour Cab",
    "Wagholi to Mumbai Luxury Car"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Wagholi to Mumbai Cab | Innova, Dzire, Ertiga & Luxury Cars</title>
  <meta
    name="description"
    content="Book reliable and affordable cabs from Wagholi to Mumbai. Innova, Dzire, Ertiga, Sedan, Tempo Traveller & luxury car options available for one way, round trip & airport transfers."
  />
  <meta
    name="keywords"
    content="Wagholi to Mumbai Taxi Service, Wagholi to Mumbai Innova Cab, Wagholi to Mumbai Dzire Taxi, Wagholi to Mumbai Airport Cab, Wagholi to Mumbai Ertiga Cab, Wagholi to Mumbai One Way Taxi, Wagholi to Mumbai Round Trip Cab, Wagholi to Mumbai Crysta Rental, Wagholi to Mumbai Sedan Taxi, Wagholi to Mumbai Etios Cab, Wagholi to Mumbai SUV Taxi, Wagholi to Mumbai Tempo Traveller, Affordable Cab from Wagholi to Mumbai, Wagholi to Mumbai Tour Cab, Wagholi to Mumbai Luxury Car"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/67.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Wagholitomumbaicab ;